import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import QRCode from "qrcode";
import Stamp from "../../image/aditvertasstamp.png";
import Rameshsign from "../../image/ramesh_sign.png";
import autoTable from "jspdf-autotable";
import UnitechHeader from "../../image/cover_letter_header.png";
import UnitechHeaderSecondPage from "../../image/coverserconf.jpg";
import UnitechFooter from "../../image/cover_letter_footer.png";
import { addCustomFonts } from "../../../utils/commonComponent/common";
import { DOMAIN } from "../../../global";

let config = {
  margin: 60,
  borderMagin: 7,
  headerHeight: 95,
  footerHeight: 45,
  fontSize: 9.3,
  cusotmerHeight: 50,
  bordergap: 2,
  currentY: 0,
};

const qrData = (url) => QRCode.toDataURL(url, { margin: 1, width: 120 });

async function renderQRCode(doc, startY, url) {
  if (!url) return startY;

  const h = doc.internal.pageSize.getHeight();
  const w = doc.internal.pageSize.getWidth();
  const size = 60, need = size + 30;

  let y = startY + 10;
  if (y + need > h - config.footerHeight) {
    doc.addPage();
    y = config.margin + config.headerHeight;
  }
  doc.addImage(await qrData(url), "PNG", w - config.margin - size, y, size, size);
  return y + need;
}

function sanitizeInput(value) {
  if (!value) return "";
  return value
    .replace(/\t/g, "")   // remove all tab characters
    .trim();              // remove leading/trailing whitespace
}

function formatDate(value, format = "DD/MM/YYYY") {
  if (value && moment(value).isValid()) {
    return moment(value).format(format);
  }
  return "";
}

// Separate function to add disclaimer to footer area
function addDisclaimerToFooter(doc, footerStartY) {
  const { getHeight: h, getWidth: w } = doc.internal.pageSize;
  const margin = config.margin - 25;
  const lineHeight = 12;
  const fullText = "Disclaimer:  1. The Inspection report does not relieve the Supplier/Manufacturer/Contractor from the responsibility of delivering material meeting contractual specifications. 2. Inspection reports cannot be reproduced, except in full.";
  
  const wrapped = doc.splitTextToSize(fullText, w() - 30);
  const totalDisclaimerHeight = wrapped.length * lineHeight;  
  // Position disclaimer just above the footer
  let startY = footerStartY - totalDisclaimerHeight + 10; // 10pt gap between disclaimer and footer  
  doc.setFontSize(config.fontSize - 1);  
  wrapped.forEach((line, i) => {
    if (i === 0) {
      doc.setFont("TimesNewRoman", "bold");
      doc.text("Disclaimer:", margin, startY);
      doc.setFont("TimesNewRoman", "normal");
      const disclaimerWidth = doc.getTextWidth("Disclaimer:");
      doc.text(line.substring(11), margin + disclaimerWidth, startY);
    } else {
      doc.setFont("TimesNewRoman", "normal");
      doc.text(line, margin, startY);
    }
    startY += lineHeight;
  });
}

// Helper function to draw the header and footer images
function addHeaderFooter(doc, isLastPage = false) {
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginX = config.margin - 81;
  const headerHeight = config?.headerHeight;
  const footerHeight = config?.footerHeight;
  const headerWidth = pageWidth - marginX * 2;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    const isCurrentPageLast = i === pageCount;    
    // --- Header ---
    const headerImage = i === 1 ? UnitechHeader : UnitechHeaderSecondPage;
    // Adjust position and height only on second page
    const marginX = 22; // increase/decrease as needed
    const headerWidth = pageWidth - marginX * 2;

    if (i === 1) {
      doc.addImage(headerImage, "PNG", marginX, 0, headerWidth - 2, headerHeight);
    } else {
      doc.addImage(headerImage, "PNG", marginX, 20, headerWidth - 2, headerHeight - 20);
    }

    // --- Footer ---
    if (i === 1) {
      // Footer image only on first page
      doc.addImage(
        UnitechFooter,
        "PNG",
        20,
        pageHeight - footerHeight - 15,
        pageWidth - marginX * 2,
        footerHeight
      );
    } else {
      // Calculate footer start position
      const footerStartY = pageHeight - footerHeight - 18;
      // --- Add Disclaimer on Last Page Only (before footer table) ---
      if (isCurrentPageLast && isLastPage) {
        addDisclaimerToFooter(doc, footerStartY);
      }      
      // Footer table on second and subsequent pages
      const tableBody = [
        [
          {
            content: "Our Services",
            styles: { fontStyle: "bold", halign: "center" },
          },
        ],
        [
          {
            content:
              "Third Party Inspection Authority / Expediting Services / Pre-Shipment, Pre-Dispatch Inspection / Vendor Assessment / NDT Services  / Consulting of EIL Shop Approval / ASME “U” & “R” Stamp / ISO Certification",
            styles: { halign: "center" },
          },
        ],
      ];

      autoTable(doc, {
        startY: footerStartY,
        margin: { left: 30, right: 30, bottom: 10 },
        body: tableBody,
        theme: "grid",
        styles: {
          font: "TimesNewRoman",
          fontSize: config.fontSize,
          textColor: 0,
          cellPadding: { left: 4, right: 4, bottom: 3, top: 3 },
          valign: "middle",
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
        columnStyles: {
          0: { cellWidth: pageWidth - 2 * 30 },
        },
      });
    }
  }
}



function renderCoverLetterHeaderSection(doc, margin, pageWidth, IRDetails, inputStates) {
  const lineHeight = 15;
  let y = config.headerHeight + margin - 40;

  // Title (centered)
  doc.setFont("TimesNewRoman", "bold");
  doc.setFontSize(config.fontSize + 3);
  doc.text("COVER LETTER", pageWidth / 2, y, { align: "center" });

  y += 2 * lineHeight;
  doc.setFontSize(config.fontSize);

  // Left-right aligned ref/date
  const letterRef = `${inputStates.reportNo || ""}`;
  const letterDate = `Date: ${formatDate(IRDetails?.issueDate || inputStates.issueDate || "")}`;
  doc.text(letterRef, margin, y);
  const textWidth = doc.getTextWidth(letterDate);
  doc.text(letterDate, pageWidth - margin - textWidth, y);

  y += 1.5 * lineHeight;

  const addressLines = [
    "To,",
    inputStates.clientId || IRDetails?.clientId || "",
  ];
  addressLines.forEach((line) => {
    if (line) {
      const splitLines = line.split("\n");
      splitLines.forEach((subLine) => {
        doc.text(subLine.trim(), margin, y);
        y += lineHeight;
      });
    }
  });

  y += 5;

  // Subject
  doc.setFont("TimesNewRoman", "bold");
  doc.text("Subject:", margin, y);
  y += lineHeight;

  // doc.setFont("TimesNewRoman", "normal");
  const subjectText = inputStates?.subjet?.trim() || IRDetails?.projectName || "";
  const subjectLines = doc.splitTextToSize(subjectText, pageWidth - 2 * margin);
  subjectLines.forEach((line) => {
    doc.text(line, margin, y);
    y += lineHeight - 1;
  });

  y += lineHeight - 5;

  // Reference
  doc.setFont("TimesNewRoman", "bold");
  doc.text("Reference:", margin, y);
  y += lineHeight;

  doc.setFont("TimesNewRoman", "normal");
  const referenceText = inputStates.reference?.trim() || IRDetails?.clientReference?.trim() || "";
  const wrapped = doc.splitTextToSize(referenceText, pageWidth - 2 * margin);
  doc.text(wrapped, margin, y);
  y += wrapped.length * lineHeight + 3;

  doc.setFont("TimesNewRoman", "bold");
  doc.text("Dear Sir,", margin, y);
  y += lineHeight + 1;

  // Body paragraph justified (simulated) with extra line spacing
  doc.setFont("TimesNewRoman", "normal");
  const bodyText = inputStates?.introduction?.trim() || "";

  const bodyLines = doc.splitTextToSize(bodyText, pageWidth - 2 * margin);
  bodyLines.forEach((line) => {
    doc.text(line, margin, y);
    y += lineHeight - 1; // Increased spacing between lines
  });
  return y + lineHeight;
}

function renderInspectionTableSection(doc, startY, margin, pageWidth, table) {
  const headers = table.header || [];
  const rows = table.body || [];

  // Generate table head from headers
  const tableHead = [
    [
      { content: "Sr.No.", styles: { halign: "center", fontStyle: "bold" } },
      ...headers.map((col) => ({
        content: col.label,
        styles: { halign: "center", fontStyle: "bold" },
      })),
    ],
  ];

  // Generate body with Sr.No and column values
  const tableBody = rows.map((row, index) => {
    const rowData = [String(index + 1)]; // Sr.No.
    headers.forEach((col) => {
      rowData.push(String(row[col.colRelation] ?? "")); // safely handle missing data
    });
    return rowData;
  });

  const margins = {
    top: config.margin + config.headerHeight - 20,
    left: config.margin,
    right: config.margin,
    bottom: config.margin + config.footerHeight - 22,
  };
  const columnCount = headers.length + 1;
  const adjustedFontSize = Math.max(
  columnCount <= 8 ? config.fontSize :
  columnCount <= 12 ? config.fontSize - 2 :
  columnCount <= 15 ? config.fontSize - 3 :
  config.fontSize - 4, 6
);

  autoTable(doc, {
    startY: startY - 10,
    margin: margins,
    head: tableHead,
    body: tableBody,
    theme: "grid",
    styles: {
      font: "TimesNewRoman",
      fontSize: adjustedFontSize,
      cellPadding: { top: 3, left: 2, bottom: 3, right: 2 },
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
      halign: "center",
    },
    headStyles: {
      fillColor: false,
    },
  });

  // Return Y after table
  return doc.lastAutoTable.finalY + 10;
}

async function renderPostTableRemarksSection(doc, startY, margin, pageWidth, inputStates) {
  startY += 10;
  const pageHeight = doc.internal.pageSize.getHeight();
  const lineHeight = 15;
  const maxY = pageHeight - config.footerHeight - 50;
  const remarks = [
    "The inspection report for the same are attached herewith for your reference and dispatch clearance has been given for the quantity mentioned above.",
    "Thanking you.",
  ];

  doc.setFont("TimesNewRoman", "normal");
  doc.setFontSize(config.fontSize);

  remarks.forEach((line) => {
    const wrapped = doc.splitTextToSize(line, pageWidth - 2 * margin);

    wrapped.forEach((subLine) => {
      if (startY + lineHeight > maxY) {
        doc.addPage();
        addHeaderFooter(doc); // add header/footer on new page
        startY = config.headerHeight + margin; // reset Y
      }
      doc.text(subLine, margin, startY);
      startY += lineHeight;
    });
  });

  startY += lineHeight; // space before image section

  // Add stamp, QR code, and signature images
  const imageHeight = 60;
  const imageWidth = 130;
  const qrSize = 60;

  if (startY + imageHeight + 20 > maxY) {
    doc.addPage();
    addHeaderFooter(doc);
    startY = config.headerHeight + margin;
  }

  const leftX = margin; // Left side (Stamp)
  const rightX = pageWidth - margin - imageWidth; // Right side (Sign)
  const centerX = (leftX + imageWidth + rightX) / 2 - qrSize / 2; // Center between stamp and sign

  // Add Stamp (left)
  try {
    doc.addImage(Stamp, "PNG", leftX, startY, imageWidth, imageHeight);
  } catch (err) {
    console.warn("Stamp image missing or failed to load.");
  }

  // Add QR Code (center)
  const qrcodeUrl = inputStates?.mode == 1 
    ? `${DOMAIN}/#/createReport/print/qr/${inputStates?.id}` 
    : `${DOMAIN}/#/editCoverLetter/print/qr/${inputStates?.jobRegisterId}`;
  
  try {
    const qrDataUrl = await qrData(qrcodeUrl);
    doc.addImage(qrDataUrl, "PNG", centerX, startY, qrSize, qrSize);
  } catch (err) {
    console.warn("QR code generation failed:", err);
  }

  // Add Signature (right)
  try {
    doc.addImage(Rameshsign, "PNG", rightX, startY, imageWidth, imageHeight - 5);
  } catch (err) {
    console.warn("Signature image missing or failed to load.");
  }

  // Add name in bold under the signature
  const nameTextY = startY + imageHeight + 5;
  doc.setFont("TimesNewRoman", "bold");
  doc.text("Ramesh S. Jadhav",rightX + (imageWidth / 2) - (doc.getTextWidth("Ramesh S. Jadhav") / 2),nameTextY);

   // Add in bold under the signature
  const aiplTextY = nameTextY + 14;
  doc.setFont("TimesNewRoman", "bold");
  doc.text("For BFI", rightX + (imageWidth / 2) - (doc.getTextWidth("For BFI") / 2), aiplTextY); // align right under signature

  return aiplTextY + lineHeight;
}

function lastpageimg(doc, startY, margin, pageWidth, IRDetails, inputStates) {
  const pageHeight = doc.internal.pageSize.getHeight();
  const imageHeight = 60;
  const imageWidth = 130;
  const maxY = pageHeight - config.footerHeight - 50; // Extra space for disclaimer
  const requiredSpace = imageHeight; // image height + text space
  // Check if we need a new page
  if (startY + requiredSpace > maxY) {
    doc.addPage();
    addHeaderFooter(doc);
    startY = config.headerHeight + margin;
  }
  startY -= 10;
  const leftX = margin;
  const rightX = pageWidth - margin - imageWidth;

  try {
    doc.addImage(Stamp, "PNG", leftX, startY, imageWidth, imageHeight);
  } catch (err) {
    console.warn("Stamp image missing or failed to load.");
  }

  try {
    doc.addImage(inputStates?.mode == 2 ? IRDetails?.inspectedBySign : inputStates?.inspectedBySign, "PNG", rightX, startY, imageWidth, imageHeight);
  } catch (err) {
    console.warn("Signature image missing or failed to load.");
  }

   // Add Inspector Name (bold) only if mode == 1
  let InspectionEngineerTextY = startY + imageHeight + 14;
  if (inputStates?.mode == 1 && inputStates?.inspectedByName) {
    doc.setFont("TimesNewRoman", "bold");
    doc.text(
      inputStates.inspectedByName,
      rightX + imageWidth - doc.getTextWidth(inputStates.inspectedByName) - 30,
      startY + imageHeight + 8
    );
    InspectionEngineerTextY += 8; 
  }

     // Add "InspectionEngineer" in bold under the signature
  doc.setFont("TimesNewRoman", "bold");
  doc.text("Inspection Engineer", rightX + imageWidth - doc.getTextWidth("Inspection Engineer") - 20, InspectionEngineerTextY);

  // Move Y after image
  return InspectionEngineerTextY + 2;
}


function renderInspectionDetailsSection(doc, yAfterContractorTable, pageWidth, referenceDocsdata,inputStates, IRDetails) {
  const content = [
    {
      title: "REFERENCE DOCUMENTS:",
       items: [
        ...(inputStates?.mode == 2
          ? referenceDocsdata?.map(ref => ref?.documents)
          : [sanitizeInput(inputStates.referenceDoc)].filter(Boolean)),
          ...(inputStates?.mode == 2 ? [sanitizeInput(IRDetails?.reportNo || "")] : [])
      ].filter(Boolean),
    },
    {
      title: "INSPECTION DETAILS:-",
      items: [sanitizeInput(inputStates.inspectionDetails)].filter(Boolean),
    },
    {
      title: "DOCUMENTS REVIEWED/ENCLOSED :-",
      items: [sanitizeInput(inputStates.documentReview)].filter(Boolean),
    },
  ];
  // Prepare autoTable rows
  const body = [];
  content.forEach((section) => {
    body.push([
      {
        content: section.title,
        styles: {
          fontStyle: "bold",
          fillColor: false,
          halign: "left",
          textColor: [0, 0, 0],
        },
      },
    ]);
    section.items.forEach((item, index) => {
      const isReference = section.title === "REFERENCE DOCUMENTS:" && inputStates?.mode == 2;
      const text = isReference ? `${index + 1}. ${item}` : item;
      body.push([
        {
          content: text,
          styles: {
            halign: "left",
            fontStyle: section.title === "REFERENCE DOCUMENTS:" ? "bold" : "normal",
            cellPadding: { top: 3, left: 12, bottom: 3, right: 5 },
          },
        },
      ]);
    });
  });
  // 🔹 REMARKS section (italic body)
  body.push([
    {
      content: "REMARKS:-",
      styles: {
        fontStyle: "bold",
        halign: "left",
        textColor: [0, 0, 0],
      },
    },
  ]);
  body.push([
    {
      content: sanitizeInput(inputStates?.remarks),
      styles: {
        halign: "left",
        fontStyle: "italic",
        cellPadding: { top: 3, left: 12, bottom: 3, right: 5 },
      },
    },
  ]);
  if (inputStates?.remarks2) {
    body.push([
      {
        content: sanitizeInput(inputStates?.remarks2),
        styles: {
          halign: "left",
          fontStyle: "normal",
          cellPadding: { top: 3, left: 12, bottom: 3, right: 5 },
        },
      },
    ]);
  }
  // 🔹 INSPECTION IDENTIFICATION section (bold title, normal text)
  body.push([
    {
      content:
        `INSPECTION IDENTIFICATION:- ${sanitizeInput(inputStates?.inspectionIdentification)}`,
      styles: {
        fontStyle: "bold",
        halign: "left",
        textColor: [0, 0, 0],
      },
    },
  ]);
  body.push([
    {
      content: `ORDER STATUS: ${sanitizeInput(inputStates?.orderStatus)}`,
      styles: {
        halign: "left",
        fontStyle: "bold",
        cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
      },
    },
  ]);

  let margins = {
    top: config?.margin + config?.headerHeight - 20,
    left: config.margin,
    right: config.margin,
    bottom: config.margin + config?.footerHeight - 22,
  };
  autoTable(doc, {
    startY: yAfterContractorTable + 5,
    margin: margins,
    body: body,
    theme: "plain",
    styles: {
      font: "TimesNewRoman",
      fontSize: config.fontSize,
      cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
      textColor: 0,
      valign: "top",
    },
    // columnStyles: {
    //   0: { cellWidth: pageWidth - 2 * margin },
    // },
  });

  return doc.lastAutoTable.finalY + 50;
}

function renderContractorDetailsTableSection(doc, margin, pageWidth,inputStates,IRDetails) {
  const lineHeight = 15;
  let y = config.headerHeight + 18;

  // 🔹 Section Title (centered)
  doc.setFont("TimesNewRoman", "bold");
  doc.setFontSize(config.fontSize + 3);
  doc.text("INSPECTION CERTIFICATE/RELEASE NOTE", pageWidth / 2, y, {
    align: "center",
  });

  y += lineHeight;

  // 🔹 Certificate Info (centered)
  doc.setFont("TimesNewRoman", "bold");
  doc.setFontSize(config.fontSize);
  const certText =
    `[CERTIFICATE NO. ${inputStates?.certificateNo || inputStates?.reportNo} Date: ${formatDate(IRDetails?.issueDate || inputStates.issueDate)}]`;
  doc.text(certText, pageWidth / 2, y, { align: "center" });
  y += 2 * lineHeight;

  const tableBody = [
    [
      {
        content: "Contractor Consignee",
        styles: { fontStyle: "bold", halign: "left" },
      },
      { content: ":", styles: { halign: "center" } },
      {
        content: sanitizeInput(inputStates?.contractorClient),
        styles: { halign: "left" },
      },
    ],
    [
      {
        content: "Contractor Name",
        styles: { fontStyle: "bold", halign: "left" },
      },
      { content: ":", styles: { halign: "center" } },
      {
        content: sanitizeInput(inputStates?.contractorConsignee),
        styles: { halign: "left" },
      },
    ],
    [
      {
        content: "Name of Manufacturer/Supplier",
        styles: { fontStyle: "bold", halign: "left" },
      },
      { content: ":", styles: { halign: "center" } },
      {
        content: sanitizeInput(inputStates?.supplierName),
      },
    ],
    [
      { content: "Work Name", styles: { fontStyle: "bold", halign: "left" } },
      { content: ":", styles: { halign: "center" } },
      {
        content:sanitizeInput(inputStates?.workName),
        styles: { fontStyle: "bolditalic", } 
      },
    ],
  ];

  let margins = {
    top: config?.margin + config?.headerHeight - 20,
    left: config.margin,
    right: config.margin,
    bottom: config.margin + config?.footerHeight - 22,
  };

  autoTable(doc, {
    startY: y - 15,
    margin: margins,
    body: tableBody,
    theme: "grid",
    styles: {
      font: "TimesNewRoman",
      fontSize: config.fontSize,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      cellPadding: 5,
      valign: "middle",
    },
     headStyles: {
      fillColor: false,
    },
  });

  return doc.lastAutoTable.finalY + 5;
}

export async function generateCoverLetterPdf(IRDetails,
  referenceDocsdata, inputStates, tableData = [], setDownloadPdfloading) {
  try {
    setDownloadPdfloading(true);
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4",
      compress: true,
    });
    // Add custom fonts to the document (await since it's async now)
    await addCustomFonts(doc);

    const margin = config.margin;
    const pageWidth = doc.internal.pageSize.getWidth();

    const headerY = renderCoverLetterHeaderSection(doc, margin, pageWidth, IRDetails, inputStates);
    let tableEndY = headerY;
    if (tableData.length > 0) {
      tableEndY = renderInspectionTableSection(
        doc,
        headerY,
        margin,
        pageWidth,
        tableData[0] // send first table object
      );
    }
    // const signimgy = renderPostTableRemarksSection(doc, tableEndY, margin, pageWidth, IRDetails);

    // let qrcodeUlr = inputStates?.mode == 1 ? `${DOMAIN}/#/createReport/print/qr/${inputStates?.id}` : `${DOMAIN}/#/editCoverLetter/print/qr/${inputStates?.jobRegisterId}`;
    await renderPostTableRemarksSection(doc, tableEndY, margin, pageWidth, inputStates);
    // await renderQRCode(doc, signimgy, qrcodeUlr);

    doc.addPage();

    const yAfterContractorTable = renderContractorDetailsTableSection(
      doc,
      margin,
      pageWidth,
      inputStates,
      IRDetails
    );
    const secondpageY = renderInspectionDetailsSection(
      doc,
      yAfterContractorTable,
      pageWidth,
      referenceDocsdata,
      inputStates,
      IRDetails
    );
    lastpageimg(doc, secondpageY, margin, pageWidth, IRDetails, inputStates);

    // Add headers, footers and page numbers to all pages
    const totalPages = doc.getNumberOfPages();
    // 🔹 Draw header/footer ONCE
    addHeaderFooter(doc, true);
    // 🔹 THEN draw page numbers
    for (let page = 1; page <= totalPages; page++) {
      doc.setPage(page);

      doc.setFont("TimesNewRoman", "bold");
      doc.setFontSize(config.fontSize - 1);
      const footerY = doc.internal.pageSize.getHeight() - config.footerHeight + 38;

      doc.text(
        `Page No : ${String(page).padStart(2, "0")} of ${String(totalPages).padStart(2, "0")}`,
        config.margin + 5,
        footerY
      );
      doc.text(
        "FormatNo.:BFI/FM/INSPN/IRN/6A,Rev-3,Rev.Date:25.09.2023",
        pageWidth - config.margin - 210,
        footerY
      );
    }

    doc.save("cover-letter.pdf");
    setDownloadPdfloading(false);
  } catch (error) {
    setDownloadPdfloading(false);
    console.log("pdf genrating error", error);
  }
}
